import { setDefaultStyle } from "apparatus/draw";
import { P, Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
import { CommonCondenser, condenserCaseShape } from "../condensers";
export class GrahamCondenser2 {
    render(appearance) {
        const { ports, height } = appearance;
        const { group: casing, snap: snapping } = condenserCaseShape(height, 15, ports);
        const insideTube1 = new Path(Segments([[7.5, 0]], [[7.5, 10]], [[5, 25]]));
        const insideTube2 = new Path(Segments([[-7.5, 0]], [[-7.5, 10]], [[-5, 25]]));
        const twists = Math.floor((height - 70) / 10);
        for (let i = 0; i < twists; i++) {
            insideTube1.addSegments(Segments([[3, 10 * i + 38],
                i == 0 ? [0, 0] : [10, -5],
                i == twists - 1 ? [0, 0] : [10, 5]]));
            insideTube2.addSegments(Segments([[-3, 10 * i + 43],
                i == 0 ? [0, 0] : [-10, -5],
                i == twists - 1 ? [0, 0] : [-10, 5]]));
        }
        insideTube1.addSegments(Segments([[5, height - 25]], [[7.5, height - 10]], [[7.5, height]]));
        insideTube2.addSegments(Segments([[-5, height - 25]], [[-7.5, height - 10]], [[-7.5, height]]));
        let graphic = new Group([casing, insideTube1, insideTube2]);
        setDefaultStyle(graphic);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            snapping,
            pivot: P(0, height / 2)
        };
    }
}
GrahamCondenser2.properties = {
    label: "Graham Condenser",
    flippable: true,
    defaultAppearance: Object.assign({}, CommonCondenser.defaultAppearance),
    appearanceSpecs: [
        ...CommonCondenser.appearanceSpecs,
    ],
    isBoostRequired: a => CommonCondenser.isBoostRequired(a)
};
